export default __webpack_public_path__ + "locales/zh-CN/Errors.json?hash=7f61a3c61e69ab5be36f0f1487806a03";